import { memo } from 'react';
import { LayoutGridIcons, TableIcons } from '../../../../../../icons/icons';
import { ViewModeToggleProps } from './interfaces';
import { ButtonBase, Stack, Typography } from '@mui/material';

export const ViewModeToggle = memo<ViewModeToggleProps>(
  ({ viewMode, setViewMode }) => (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        gap: 0.25,
        borderRadius: '8px',
        border: '1px solid',
        borderColor: '#e2e8f0',
        bgcolor: 'rgba(241,245,249,0.7)',
        p: 0.25,
      }}
    >
      <ButtonBase
        onClick={() => setViewMode('table')}
        title="Table view"
        aria-label="Switch to table view"
        aria-pressed={viewMode === 'table'}
        sx={{
          minHeight: 32,
          borderRadius: '6px',
          px: 1,
          transition: 'all 0.3s',
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
          fontSize: '12px',
          fontWeight: 600,
          whiteSpace: 'nowrap',
          ...(viewMode === 'table'
            ? {
                bgcolor: '#e2e8f0',
                color: '#0f172a',
                boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
              }
            : {
                color: '#64748b',
                '&:hover': {
                  color: '#0f172a',
                  bgcolor: 'rgba(241,245,249,0.6)',
                },
              }),
        }}
      >
        <TableIcons size={12} />
        <Typography
          component="span"
          sx={{
            fontSize: 'inherit',
            fontWeight: 'inherit',
            display: { xs: 'none', lg: 'block' },
          }}
        >
          Table
        </Typography>
      </ButtonBase>

      <ButtonBase
        onClick={() => setViewMode('grid')}
        title="Chart view"
        aria-label="Switch to chart view"
        aria-pressed={viewMode === 'grid'}
        sx={{
          minHeight: 32,
          borderRadius: '6px',
          px: 1,
          transition: 'all 0.3s',
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
          fontSize: '12px',
          fontWeight: 600,
          whiteSpace: 'nowrap',
          ...(viewMode === 'grid'
            ? {
                bgcolor: '#e2e8f0',
                color: '#0f172a',
                boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
              }
            : {
                color: '#64748b',
                '&:hover': {
                  color: '#0f172a',
                  bgcolor: 'rgba(241,245,249,0.6)',
                },
              }),
        }}
      >
        <LayoutGridIcons size={12} />
        <Typography
          component="span"
          sx={{
            fontSize: 'inherit',
            fontWeight: 'inherit',
            display: { xs: 'none', md: 'block' },
          }}
        >
          Charts
        </Typography>
      </ButtonBase>
    </Stack>
  ),
);

ViewModeToggle.displayName = 'ViewModeToggle';
